import { motion } from "framer-motion";
import { ReactNode } from "react";
import { useRouter } from "next/router";

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  const router = useRouter();
  const isDetail = router.pathname.includes("[id]");

  // 根据是否是详情页决定动画方向
  const direction = isDetail ? 1 : -1;

  return (
    <motion.div
      initial={{ opacity: 0, x: `${100 * direction}%` }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: `${-100 * direction}%` }}
      transition={{
        duration: 0.3,
        ease: [0.25, 0.1, 0.25, 1], // iOS 风格的缓动函数
      }}
      className="w-full fixed inset-0 bg-[var(--theme-page-bg)] text-[var(--theme-text-primary)] native-scroll"
      style={{
        willChange: "transform",
        backfaceVisibility: "hidden",
        WebkitBackfaceVisibility: "hidden",
        transform: "translateZ(0)",
      }}
    >
      {children}
    </motion.div>
  );
}
